import { TableControls } from "src/components/Table";

import {
  AdminSort,
  AdminStatus,
  ADMIN_SORTS,
  ADMIN_STATUSES
} from "./constants";

export default function AdminListControls({
  onClickInvite,
  statusFilter,
  setStatusFilter,
  search,
  setSearch,
  sort,
  setSort
}: {
  onClickInvite: () => void;
  statusFilter: AdminStatus;
  setStatusFilter: (newStatusFilter: AdminStatus) => void;
  search: string;
  setSearch: (newSearch: string) => void;
  sort: AdminSort;
  setSort: (newSort: AdminSort) => void;
}): JSX.Element {
  return (
    <TableControls
      addButtons={[{ label: "Invite Admin", onClick: onClickInvite }]}
      filters={[
        {
          label: "Admin Status",
          value: statusFilter,
          onChange: (value: string) => setStatusFilter(value as AdminStatus),
          options: ADMIN_STATUSES.map(status => ({
            value: status.key,
            label: status.label
          }))
        }
      ]}
      sort={{
        value: sort,
        onChange: value => setSort(value as AdminSort),
        options: ADMIN_SORTS.map(sort => ({
          value: sort.key,
          label: sort.label
        }))
      }}
      search={{
        value: search,
        onChange: setSearch,
        placeholder: "Search for an admin..."
      }}
    />
  );
}
